import React from 'react';
import Navbar from './components/Navbar';
import OurMission from './components/Our-Mission-Career';
import JoinOurTeams from './components/Join-Our-Team';
import JobListingsWithHover from './components/Open-Position';
import WhyJoinUs from './components/Why-Join-Us';
import Footer from './components/Footer';

export default function Career() {
  return (
    <div>
    <Navbar />
    <div style={styles.container}>
      <div style={styles.backgroundOverlay}>
        <div style={styles.geometricShape1}></div>
        <div style={styles.geometricShape2}></div>
        <div style={styles.geometricShape3}></div>
        <div style={styles.geometricShape4}></div>
        <div style={styles.geometricShape5}></div>
      </div>

      {/* Main Content */}
      <div style={styles.content}>
        <h1 style={styles.title}>
          Shape the Future of AI Education
        </h1>
        
        <p style={styles.subtitle}>
          Join our global mission to democratize AI education and empower the next generation of innovators
        </p>

        <div style={styles.buttonContainer}>
          <button style={styles.primaryButton}>
            <span style={styles.buttonIcon}>🚀</span>
            View Open Positions
          </button>
          
          <button style={styles.secondaryButton}>
            <span style={styles.buttonIcon}>👥</span>
            Learn About Our Culture
          </button>
        </div>
      </div>

      {/* Floating particles for extra effect */}
      <div style={styles.particle1}></div>
      <div style={styles.particle2}></div>
      <div style={styles.particle3}></div>
      <div style={styles.particle4}></div>
    </div>
    <OurMission />
    <JoinOurTeams />
    <JobListingsWithHover />
    <WhyJoinUs />
    <Footer />
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },

  backgroundOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0.1,
  },

  geometricShape1: {
    position: 'absolute',
    top: '10%',
    left: '15%',
    width: '200px',
    height: '200px',
    background: 'linear-gradient(45deg, #8b5cf6, #a855f7)',
    clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
    animation: 'float 6s ease-in-out infinite',
  },

  geometricShape2: {
    position: 'absolute',
    top: '20%',
    right: '10%',
    width: '150px',
    height: '150px',
    background: 'linear-gradient(45deg, #3b82f6, #6366f1)',
    borderRadius: '50%',
    animation: 'float 8s ease-in-out infinite reverse',
  },

  geometricShape3: {
    position: 'absolute',
    bottom: '15%',
    left: '10%',
    width: '180px',
    height: '180px',
    background: 'linear-gradient(45deg, #ec4899, #f472b6)',
    clipPath: 'polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)',
    animation: 'float 7s ease-in-out infinite',
  },

  geometricShape4: {
    position: 'absolute',
    bottom: '25%',
    right: '20%',
    width: '120px',
    height: '120px',
    background: 'linear-gradient(45deg, #10b981, #34d399)',
    transform: 'rotate(45deg)',
    animation: 'float 5s ease-in-out infinite',
  },

  geometricShape5: {
    position: 'absolute',
    top: '50%',
    left: '5%',
    width: '100px',
    height: '100px',
    background: 'linear-gradient(45deg, #f59e0b, #fbbf24)',
    clipPath: 'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
    animation: 'float 9s ease-in-out infinite reverse',
  },

  content: {
    textAlign: 'center',
    zIndex: 2,
    maxWidth: '900px',
    padding: '0 20px',
  },

  title: {
    fontSize: 'clamp(3rem, 8vw, 6rem)',
    fontWeight: '800',
    background: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 50%, #3b82f6 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '2rem',
    lineHeight: '1.1',
    letterSpacing: '-0.02em',
    animation: 'glow 3s ease-in-out infinite alternate',
  },

  subtitle: {
    fontSize: 'clamp(1.1rem, 2.5vw, 1.5rem)',
    color: '#cbd5e1',
    marginBottom: '3rem',
    lineHeight: '1.6',
    maxWidth: '700px',
    margin: '0 auto 3rem auto',
  },

  buttonContainer: {
    display: 'flex',
    gap: '1.5rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },

  primaryButton: {
    background: 'linear-gradient(135deg, #8b5cf6, #a855f7)',
    border: 'none',
    borderRadius: '50px',
    padding: '18px 36px',
    fontSize: '1.1rem',
    fontWeight: '600',
    color: 'white',
    cursor: 'default',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0 10px 30px rgba(139, 92, 246, 0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
  },

  secondaryButton: {
    background: 'rgba(255, 255, 255, 0.1)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '50px',
    padding: '16px 34px',
    fontSize: '1.1rem',
    fontWeight: '600',
    color: 'white',
    cursor: 'default',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },

  buttonIcon: {
    fontSize: '1.2rem',
  },

  particle1: {
    position: 'absolute',
    top: '20%',
    left: '25%',
    width: '4px',
    height: '4px',
    background: '#8b5cf6',
    borderRadius: '50%',
    animation: 'twinkle 2s ease-in-out infinite',
  },

  particle2: {
    position: 'absolute',
    top: '60%',
    right: '30%',
    width: '6px',
    height: '6px',
    background: '#ec4899',
    borderRadius: '50%',
    animation: 'twinkle 3s ease-in-out infinite 0.5s',
  },

  particle3: {
    position: 'absolute',
    bottom: '30%',
    left: '40%',
    width: '3px',
    height: '3px',
    background: '#3b82f6',
    borderRadius: '50%',
    animation: 'twinkle 2.5s ease-in-out infinite 1s',
  },

  particle4: {
    position: 'absolute',
    top: '40%',
    right: '15%',
    width: '5px',
    height: '5px',
    background: '#10b981',
    borderRadius: '50%',
    animation: 'twinkle 4s ease-in-out infinite 1.5s',
  },
};

// Adding CSS animations via style tag
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }

  @keyframes glow {
    0% { text-shadow: 0 0 20px rgba(139, 92, 246, 0.5); }
    100% { text-shadow: 0 0 40px rgba(139, 92, 246, 0.8), 0 0 60px rgba(236, 72, 153, 0.3); }
  }

  @keyframes twinkle {
    0%, 100% { opacity: 0.3; transform: scale(1); }
    50% { opacity: 1; transform: scale(1.5); }
  }

  button:hover {
    transform: translateY(-2px);
  }

  button:active {
    transform: translateY(0px);
  }

  .primary-button:hover {
    box-shadow: 0 15px 40px rgba(139, 92, 246, 0.4);
  }

  .secondary-button:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 768px) {
    .button-container {
      flex-direction: column;
      align-items: center;
    }
    
    button {
      width: 100%;
      max-width: 300px;
      justify-content: center;
    }
  }
`;

document.head.appendChild(styleSheet);